import { api } from "@/lib/api";

const loadScript = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

// Creates the order server-side, opens Razorpay, verifies the signature. Resolves "paid" | "dismissed".
export async function payWithRazorpay(payload, description) {
  const { data } = await api.post("/payments/order", payload);
  const ok = await loadScript();
  if (!ok) throw new Error("Could not load the payment window. Please check your connection.");
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: data.key_id,
      amount: data.amount,
      currency: data.currency,
      order_id: data.order_id,
      name: "HithAyu Wellness",
      description,
      prefill: { name: payload.name, contact: payload.phone },
      theme: { color: "#1F3A2B" },
      handler: async (res) => {
        try {
          await api.post("/payments/verify", res);
          resolve("paid");
        } catch (e) {
          reject(e);
        }
      },
      modal: { ondismiss: () => resolve("dismissed") },
    });
    rzp.open();
  });
}
